<template>
  <!-- 物业服务企业组件 -->
  <div class="propertyComp">
    <div class="propertySelect">
      <div class="head">
        <!-- 标题 -->
        <p>选择物业服务企业</p>
        <i class="el-icon-close" @click="tipHide"></i>
      </div>
      <div class="housManageNav">
        <label class="ft14 col-33 mar-l">机构代码：</label>
        <div class="inp">
          <el-input
            v-model="numInp"
            placeholder="请输入"
            @focus="removeEventListener()"
            @blur="addEventListener()"
            size="mini"
          ></el-input>
        </div>
        <label class="ft14 col-33 mar-l">物业服务企业名称：</label>
        <div class="inp">
          <el-input
            v-model="nameInp"
            placeholder="请输入"
            @focus="removeEventListener()"
            @blur="addEventListener()"
            size="mini"
          ></el-input>
        </div>
        <ps-search @click="query"></ps-search>
      </div>
      <div class="dataList">
        <el-table
          highlight-current-row
          @cell-click="handleCurrentChange"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          height="280"
        >
          <el-table-column type="index" label="序号" width="60" align="center" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column
                label="行政区域"
                min-width="120"
                align="center"
                show-overflow-tooltip
              >
              <template slot-scope="scope">{{nationalRegion[scope.row.CantonCode]}}</template>
          </el-table-column>-->
          <el-table-column
            prop="OrgCode"
            label="机构代码"
            min-width="150"
            align="center"
            header-align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="OrgName"
            label="物业服务企业名称"
            min-width="200"
            align="center"
            header-align="center"
            show-overflow-tooltip
          ></el-table-column>
          <slot></slot>
        </el-table>
      </div>
      <div class="housManageFoot ub ub-pe ub-ac">
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="pageChange"
            :current-page="currentPage"
            :page-sizes="[20, 40, 60, 100]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- <div class="mask"></div> -->
  </div>
</template>

<script>
import nationalRegion from '@/utils/nationalRegion';
import { OrganizationBaseSvr } from '@/service/OrganizationBaseSvr.js';
import { RealtyMgeComQueryPara } from '@/models/queryparams/RealtyMgeComQueryPara'; //物业服务企业实体
import { mapState } from 'vuex';
export default {
  data() {
    return {
      total: 0, //总页
      currentPage: 1, //当前页
      pageSize: 20,
      numInp: '',
      nameInp: '',
      propertyVal: '', //选中的物业区域
      table: '机构',
      tableData: [],
      nationalRegion: nationalRegion,
      loading: false,
      organizationBaseSvr: new OrganizationBaseSvr(),
      realtyMgeComQueryPara: new RealtyMgeComQueryPara()
    };
  },
  props: [],
  computed: {
    ...mapState(['token'])
  },
  watch: {},
  created() {},
  mounted() {
    let dom = document.querySelector('.propertySelect');
    this.addEventListener(dom);
    if (document.body.clientWidth - this.getOffsetLeft(dom) < dom.clientWidth) {
      dom.style.left =
        document.body.clientWidth -
        this.getOffsetLeft(dom) -
        dom.clientWidth -
        50 +
        'px';
    }
    this.getData();
  },
  methods: {
    getOffsetLeft(obj) {
      var tmp = obj.offsetLeft;
      var val = obj.offsetParent;
      while (val != null) {
        tmp += val.offsetLeft;
        val = val.offsetParent;
      }
      return tmp;
    },
    getData() {
      this.loading = true;
      this.organizationBaseSvr
        .GetRealtyMgeComList(
          this.token,
          this.realtyMgeComQueryPara,
          (this.currentPage - 1) * this.pageSize,
          this.pageSize,
          false,
          true
        )
        .then(res => {
          this.total = res.TotalCount;
          this.tableData = res._Items;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err.Msg
          });
        });
    },
    //关闭弹窗
    tipHide() {
      this.$store.state.propertyComp = false;
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    //控制每页大小
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    //选取事件
    handleCurrentChange(val) {
      this.$emit('getPropertyVal', val);
      this.$store.state.propertyComp = false;
    },
    //查询功能
    query() {
      this.currentPage=1;
      if (this.nameInp) {
        this.realtyMgeComQueryPara.setParamByOrgName('%' + this.nameInp + '%');
      } else {
        this.realtyMgeComQueryPara.setParamByOrgName('');
      }
      this.realtyMgeComQueryPara.setParamByOrgCode(this.numInp);
      this.getData();
    },
    leaveHandle() {
      this.$store.state.propertyComp = false;
    },
    // 移除鼠标移出监听
    removeEventListener() {
      let dom = document.querySelector('.propertySelect');
      dom.removeEventListener('mouseleave', this.leaveHandle);
    },
    // 添加事件监听
    addEventListener() {
      let dom = document.querySelector('.propertySelect');
      dom.addEventListener('mouseleave', this.leaveHandle);
    }
  }
};
</script>
<style lang='scss'>
.propertyComp {
  // position: fixed;
  // left: 0;
  // top: 0;
  // bottom: 0;
  // right: 0;
  .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
  .el-input__inner {
    border: 1px solid #dcdfe6 !important;
  }
  .el-icon-circle-check {
    display: none !important;
  }
  .el-input__validateIcon {
    display: none !important;
  }
  .housManageFoot {
    height: 40px;
    background: #ebebeb;
    .pagination {
      height: 30px;
      .el-input__inner {
        height: 28px;
        line-height: 28px;
      }
      .el-input,
      .el-input--mini {
        height: 28px;
        width: 100px !important;
      }
      .el-pagination__editor {
        width: 46px !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.propertyComp {
  height: 100%;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    background: #000;
    opacity: 0.5;
    height: 100%;
    width: 100%;
    z-index: 9;
  }
  .propertySelect {
    position: absolute;
    top: 40px;
    background: #fff;
    border: 1px solid #ccc;
    width: 700px;
    height: 402px;
    z-index: 9;
    .head {
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      background: #f3f5f9;
      border-bottom: 1px solid #ccc;
      padding: 0 20px;
      align-items: center;
      .el-icon-close {
        font-weight: 600;
      }
    }
    .housManageNav {
      height: 40px;
      line-height: 40px;
      display: flex;
      background: #f3f5f9;
      border-bottom: 1px solid #ccc;
      align-items: center;
      .el-button {
        height: 34px;
        margin-left: 20px;
      }
    }
    // .dataList {
    //   height: 280px;
    //   overflow-y: scroll;
    //   &::-webkit-scrollbar {
    //     display: none;
    //   }
    // }
    .housManageFoot {
      height: 40px;
      background: #ebebeb;
      .el-input__inner {
        height: 28px;
        line-height: 28px;
      }
    }
  }
}
</style>

